import { useLocation, useMatch, useNavigate } from "@reach/router";
import { Col, Menu, Row } from "antd";
import { observer } from "mobx-react-lite";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { useStore } from "../../store";

const styles = {
  administration: {
    float: "right" as const,
  },
};

interface Props {}
const Header = (props: Props) => {
  const { multivers } = useStore();
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const match = useMatch(":administrationId/:key");
  const navigate = useNavigate();

  const administrationId = match?.administrationId || pathname.split("/")[1];

  const administration = useMemo(
    () =>
      administrationId ? multivers.administration(administrationId) : undefined,
    [administrationId]
  );

  const gotoPage = (key: string) => () => {
    navigate(`${administrationId ? `/${administrationId}` : pathname}/${key}`);
  };

  const gotoAdministration = (key: string) => () => {
    const parts = pathname.split("/");
    parts[1] = key;
    navigate(parts.join("/"));
  };
  return (
    <Row>
      <Col flex="auto">
        <Menu theme="dark" mode="horizontal" selectedKeys={[pathname]}>
          {pathname !== "/" && (
            <>
              <Menu.Item
                key={`/${administrationId}/order`}
                onClick={gotoPage("order")}
              >
                {t("Orders")}
              </Menu.Item>
              <Menu.Item
                key={`/${administrationId}/user`}
                onClick={gotoPage("user")}
              >
                {t("Users")}
              </Menu.Item>
              <Menu.Item
                key={`/${administrationId}/multivers`}
                onClick={gotoPage("multivers")}
              >
                {t("Multivers")}
              </Menu.Item>
              <Menu.Item
                key={`/${administrationId}/report`}
                onClick={gotoPage("report")}
              >
                {t("Reports")}
              </Menu.Item>
            </>
          )}
        </Menu>
      </Col>
      {administration && (
        <Col flex="200px">
          <Menu
            theme="dark"
            mode="horizontal"
            selectedKeys={[administrationId]}
          >
            <Menu.SubMenu
              key="administration"
              title={administration?.description}
              style={styles.administration}
            >
              {multivers.administrations.docs.map((admin) => (
                <Menu.Item
                  key={admin.id || ""}
                  onClick={gotoAdministration(admin.id || "")}
                >
                  {admin?.description}
                </Menu.Item>
              ))}
            </Menu.SubMenu>
          </Menu>
        </Col>
      )}
    </Row>
  );
};

export default observer(Header);
